/* eslint-disable @typescript-eslint/no-floating-promises */

"use client";

import { pageEvent } from "@acko-tech/building-blocks.ui.acko-analytics";
import { waitForAnalyticsLoad } from "@utils/analytics";
import { getDevicePlatform } from "@utils/device-utils";
import { useEffect } from "react";
import { getOsAndBrowser } from "@utils/client/deviceUtils";
import { getSegmentEventCommonProps } from "@utils/segment";

interface PageLoadEventProps {
  viewEventName: string;
  properties?: object;
  propertiesFunc?: Function;
  ekind?: string;
}

const PageLoadEvent = ({ viewEventName, properties = {}, propertiesFunc, ekind }: PageLoadEventProps) => {
  //   useIdentifyEvent(); TODO ask
  useEffect(() => {
    const allProperties = { ...properties, ...getOsAndBrowser() };
    (async () => {
      const segmentProps = await getSegmentEventCommonProps()
      waitForAnalyticsLoad()
        .then(() => {
          pageEvent(viewEventName, {
            ...allProperties,
            ...segmentProps,
            ...(propertiesFunc ? propertiesFunc() : {}),
          });
        })
        .catch((err) => {
          console.log("Wait for analytics load error", err);
        });
    })();
  }, []);

  return null;
};

export default PageLoadEvent;
